export enum ActiveTab {
  CURRENT = 'current',
  PAST = 'past',
}
